import type {
  ModalContentProps,
  ModalProps
} from '@chakra-ui/react'
import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay
} from '@chakra-ui/react'
import React from 'react'

export type ConfirmModalProps = {
  title?: string | React.ReactNode
  children?: string | React.ReactNode
  yesButton?: React.ReactNode
  noButton?: React.ReactNode
  yesButtonContent?: string | React.ReactNode
  noButtonContent?: string | React.ReactNode
  isOpen: boolean
  onClose: (result: boolean) => void
  modalContentProps?: ModalContentProps
} & Omit<ModalProps, 'onClose'>

export const ConfirmModal = ({
  title,
  children,
  isOpen,
  onClose,
  yesButtonContent,
  noButtonContent,
  yesButton,
  noButton,
  modalContentProps,
  ...rest
}: ConfirmModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={() => onClose(false)} {...rest}>
      <ModalOverlay />
      <ModalContent {...modalContentProps}>
        <ModalCloseButton />
        {title && <ModalHeader>{title}</ModalHeader>}
        <ModalBody>
          {children && children}

          {(yesButtonContent || noButtonContent || yesButton || noButton) &&
            <Flex sx={{ width: '100%', alignItems: 'center', gap: 4, justifyContent: 'center', mt: 8 }}>
              {noButton && noButton}

              {noButtonContent &&
                <Button
                  colorScheme='gray'
                  onClick={() => onClose(false)}
                >
                  {noButtonContent}
                </Button>
              }

              {yesButton && yesButton}

              {yesButtonContent &&
                <Button
                  colorScheme="green"
                  onClick={() => onClose(true)}
                >
                  {yesButtonContent}
                </Button>
              }
            </Flex>
          }
        </ModalBody>
        <ModalFooter></ModalFooter>
      </ModalContent>
    </Modal >
  )
}